module.exports = __webpack_public_path__ + "static/img/ylwsIcon.968e40cd.png";